import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { MatOptionSelectionChange } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'opt-select-configuration-combined-room',
  templateUrl: './select-configuration-combined-room.component.html'
})
export class SelectConfigurationCombinedRoomComponent implements OnInit, OnChanges {



  //passing data to configuration-option-768
  @Input() displayMode: number;
  @Input() configurations: any[];
  @Output() messageEvent = new EventEmitter<string>();
  @Input() selectedConfiguration: any;
  selectedConfigurationId: string;
  //edit model ekata danna me tika

  reciveMessage: any;
  modeMessage = 1;
  public dropDownMessage: any[];
  //configurationsToDisplay: any[];

  constructor(public dialog: MatDialog) { }

  ngOnInit() {
    console.log(this.configurations)
    //this.configurationsToDisplay = this.configurations;
  }

  changeConfiguration(event) {
    if ((event?.isUserInput != undefined && event.isUserInput == true) || event.isUserInput == undefined) {
      const changeConfigurationId = event.source.value;
      this.selectedConfigurationId = event.source.value;
      this.messageEvent.emit(changeConfigurationId);
    }
  }

  setDefaultConfiguration() {
    if (this.configurations?.length > 0) {
      if(this.selectedConfiguration == undefined) {
        const configId = this.configurations[0].id;
        this.selectedConfigurationId = configId;
        this.changeConfiguration({
          source: { value: configId },
          isUserInput: undefined,
        });
      }

    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.configurations) {
      // If configurations input property has changed
      console.log('Configurations changed:', changes.configurations);
      if(this.selectedConfiguration != undefined) {
        this.selectedConfigurationId = this.selectedConfiguration?.id;
      }
      //  this.configurationsToDisplay = [...changes.configurations.currentValue]
      // Emit an event that configurations changed
      // this.messageEvent.emit('Configurations updated!');
    }

    if (changes.selectedConfiguration && changes.selectedConfiguration != null) {
      // If selectedConfiguration input property has changed
      console.log('Selected Configuration changed:', changes.selectedConfiguration);
      //   this.selectedConfigurationId = changes.selectedConfiguration?.currentValue?.value ?? "";
      // Emit an event for selectedConfiguration change
      //this.messageEvent.emit('Selected Configuration updated!');
    }
    this.setDefaultConfiguration();
  }
}
